import { db } from '@/shared/services/firebase'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async fetchOpenShifts(ctx, { accountId, callback }) {
      try {
        let query = db.collection('shifts')
          .where('status', '==', 'open')
          .where('start', '>', new Date())
        if (accountId) {
          query = query.where('accountId', '==', accountId)
        }
        query.onSnapshot(snapshot => {
          const shifts = snapshot.docs.map(shift => ({
            ...shift.data(),
            id: shift.id,
            title: `${shift.data().start.toDate().getDate() < 10 ? '0' : ''}${shift.data().start.toDate().getDate()}.${(shift.data().start.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.data().start.toDate().getMonth() + 1}. ${shift.data().title.slice(0, 1).toUpperCase()}${shift.data().title.slice(1).toLowerCase()}`
          }))
          callback(shifts)
        })
      } catch (e) {
        console.error(e)
      }
    },
    async fetchUpcomingShifts(ctx, { accountId, callback }) {
      try {
        let query = db.collection('shifts')
          .where('status', '==', 'booked')
          .where('start', '>', new Date())
          .where('reserved', '==', true)
        if (accountId) {
          query = query.where('accountId', '==', accountId)
        }
        query.onSnapshot(async snapshot => {
          const shifts = await Promise.all(snapshot.docs.map(async shift => {
            const userDoc = await db.collection('users')
              .doc(shift.data().assignedTo)
              .get()
            const user = {
              ...userDoc.data(),
              id: userDoc.id,
            }
            const assignee = `${user.firstName.slice(0, 1).toUpperCase()}${user.firstName.slice(1).toLowerCase()} ${user.lastName.slice(0, 1).toUpperCase()}${user.lastName.slice(1).toLowerCase()}`
            return {
              ...shift.data(),
              id: shift.id,
              assignee,
              title: `${shift.data().start.toDate().getDate() < 10 ? '0' : ''}${shift.data().start.toDate().getDate()}.${(shift.data().start.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.data().start.toDate().getMonth() + 1}. ${shift.data().title.split(':')[1].trim().slice(0, 1).toUpperCase()}${shift.data().title.split(':')[1].trim().slice(1).toLowerCase()}`
            }
          }))
          callback(shifts)
        })
      } catch (e) {
        console.error(e)
      }
    },
    async fetchInProgressShifts(ctx, { accountId, callback }) {
      try {
        let query = db.collection('shifts')
          .where('status', '==', 'booked')
          .where('start', '<', new Date())
          .where('reserved', '==', true)
        if (accountId) {
          query = query.where('accountId', '==', accountId)
        }
        query.onSnapshot(async snapshot => {
          const shifts = await Promise.all(snapshot.docs.filter(shift => shift.data().end.toDate() > new Date()).map(async shift => {
            const userDoc = await db.collection('users').doc(shift.data().assignedTo).get()
            const user = {
              ...userDoc.data(),
              id: userDoc.id,
            }
            const assignee = `${user.firstName.slice(0, 1).toUpperCase()}${user.firstName.slice(1).toLowerCase()} ${user.lastName.slice(0, 1).toUpperCase()}${user.lastName.slice(1).toLowerCase()}`
            return {
              ...shift.data(),
              id: shift.id,
              assignee,
              title: `${shift.data().start.toDate().getDate() < 10 ? '0' : ''}${shift.data().start.toDate().getDate()}.${(shift.data().start.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.data().start.toDate().getMonth() + 1}. ${shift.data().title.split(':')[1].trim().slice(0, 1).toUpperCase()}${shift.data().title.split(':')[1].trim().slice(1).toLowerCase()}`
            }
          }))
          callback(shifts)
        })
      } catch (e) {
        console.error(e)
      }
    }
  },
}
